import React, { useCallback, useState } from 'react';
import WaAdminShell from '../../components/admin/whatsapp/WaAdminShell';
import WaLogThread from '../../components/admin/whatsapp/WaLogThread';
import { fetchWaLogs, waLogsExportUrl } from '../../utils/adminWhatsapp';

const PAGE = 50;

export default function WhatsAppLogs() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [direction, setDirection] = useState('');
  const [phone, setPhone] = useState('');
  const [skip, setSkip] = useState(0);
  const [expanded, setExpanded] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchWaLogs({
        direction: direction || undefined,
        phone: phone.trim() || undefined,
        limit: PAGE,
        skip,
      });
      setLogs(data.logs || []);
      setTotal(data.total || 0);
    } catch {
      setLogs([]);
    } finally {
      setLoading(false);
    }
  }, [direction, phone, skip]);

  React.useEffect(() => {
    load();
  }, [load]);

  return (
    <WaAdminShell title="Message logs" subtitle="Inbound and outbound WhatsApp traffic">
      <div className="flex flex-wrap gap-3 mb-4 items-end">
        <label className="text-sm">
          Direction
          <select className="block border rounded-lg mt-1 px-2 py-1" value={direction} onChange={(e) => { setSkip(0); setDirection(e.target.value); }}>
            <option value="">All</option>
            <option value="inbound">Inbound</option>
            <option value="outbound">Outbound</option>
          </select>
        </label>
        <label className="text-sm flex-1 min-w-[160px]">
          Phone (E.164)
          <input
            className="block w-full border rounded-lg mt-1 px-2 py-1"
            placeholder="+91…"
            value={phone}
            onChange={(e) => { setSkip(0); setPhone(e.target.value); }}
          />
        </label>
        <button type="button" onClick={load} className="px-3 py-2 text-sm border rounded-lg">Search</button>
        <a href={waLogsExportUrl()} className="px-3 py-2 text-sm bg-[#1B375B] text-white rounded-lg" target="_blank" rel="noreferrer">
          Export CSV
        </a>
      </div>
      <p className="text-sm text-gray-500 mb-2">{total} messages · showing {skip + 1}–{Math.min(skip + PAGE, total)}</p>
      <div className="bg-white border rounded-xl">
        <WaLogThread messages={logs} expandedId={expanded} onToggle={setExpanded} />
      </div>
      <div className="flex gap-2 mt-4 justify-center">
        <button type="button" disabled={skip === 0} className="px-3 py-1 border rounded-lg text-sm disabled:opacity-40" onClick={() => setSkip((s) => Math.max(0, s - PAGE))}>
          Previous
        </button>
        <button type="button" disabled={skip + PAGE >= total} className="px-3 py-1 border rounded-lg text-sm disabled:opacity-40" onClick={() => setSkip((s) => s + PAGE)}>
          Next
        </button>
      </div>
    </WaAdminShell>
  );
}
